<article class="page-header-article" tuiHeader="xxl">
    <h1 tuiTitle>
        {{ title }}
        <div tuiSubtitle>{{ subtitle }}</div>
    </h1>
</article>
